import type {Step} from "../components/stepper/Step.ts";
import {useMetlConnectionStep} from "../common-process/1-metl-connection/useMetlConnectionStep.tsx";
import {useAnalysisOptionsStep} from "./2-option-selection/useAnalysisOptionsStep.tsx";
import {useScanStep} from "./3-perform-scan/useScanStep.ts";
import {useUploadResultsStep} from "./4-upload-results/useUploadResultsStep.tsx";

export function useAnalysisProcessSteps(): Step[] {
    return [
        useMetlConnectionStep(),
        useAnalysisOptionsStep(),
        useScanStep(),
        useUploadResultsStep(),
        // useDownloadArtifactsStep()
    ]
}